<template>
	<div style="width:160px;">
		<div :style="style.display">{{display}}</div>
		<div>
			<btn v-for="key in keys" :key="key" icon="user" iconLeft type="primary" size="large" v-on:press="onPress" :label="key"/>
			<input
			  v-bind:value="display"
			  v-on:input="display = $event.target.value">
		</div>	
	</div>
</template>



<script>
	import Btn from './button.vue';
	export default {
		components:{Btn},
	    methods: {
	        onPress: function(key) {
	            this.display = this.display + key;
	        }
	    },
	    data() {
	        return {
		        display: "0",
		        keys: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "+","-","*","/","%","=","+/-"],
	            style: {
	            	display:{
	            		padding:"10px",
	            		fontSize:"32px",
	            		background:'red'
	            	}

	            }
	        }
	    }
	};
</script>

